<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" class="cadastre-building" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Номи <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.name"
                                :class="{'is-invalid': $v.data.name.$error}"
                                @blur="$v.data.name.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.name.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameUz")}}</div>
                    </div>
                    <div class="form-group">
                        <label>Номи(ru) <span class="red">*</span></label>
                        <input
                                type="text"
                                class="form-control"
                                v-model="data.nameRu"
                                :class="{'is-invalid': $v.data.nameRu.$error}"
                                @blur="$v.data.nameRu.$touch()"
                        />
                        <div class="invalid-feedback" v-if="$v.data.nameRu.$error">{{$t("realEstate.validation.cadastreBuildingFieldReferenceEdit.nameRu")}}</div>
                    </div>
                    <div class="form-group">
                      <label>Манзил </label>
                      <input
                          type="text"
                          class="form-control"
                          v-model="data.address"
                      />
                    </div>
                    <div class="form-group">
                        <label>Тартиб </label>
                        <numeric-input v-model="data.sortOrder"></numeric-input>
                    </div>
                    <div class="form-check">
                        <label class="form-check-label pl-0">
                            <input class="form-check-input" type="checkbox" v-model="data.active">
                            <span class="form-check-sign"></span>
                            Актив
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {numericTypes} from '@/shared/constants/mask'
    import {required} from 'vuelidate/lib/validators';
    import {clone} from '@/shared/utils';

    export default {
        name: "Expert2OrganizationEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                data: this.initEmptyData(),
            }
        },
        validations() {
            return {
                data:{
                    name:{
                        required
                    },
                    nameRu: {
                        required
                    }
                }
            }
        },
        methods: {
            initEmptyData() {
                return {
                    name: '',
                    nameRu: '',
                    active: false,
                    sortOrder: 1,
                    address: ''
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const vm = this;
                this.processing = true;

                this.$http.post('expert2/organization', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change');
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on('showExpert2OrganizationEditModal', (data) => {
                if (data) {
                    this.data = clone(data)
                } else {
                    this.data = this.initEmptyData();
                }
                this.show = true;
            })
        }
    }
</script>

<style scoped>

</style>